<template>
  <div class="projects-box">
    <menuBox :step="4"></menuBox>
    <div class="title-box">
      <div class="title">
        <p>ความแข็งแกร่งของทีม</p>
        <span>ช่างฝีมือของเราใช้ทักษะเฉพาะตัวและการแสวงหาคุณภาพที่ไม่มีใครเทียบได้เพื่อสร้างผลิตภัณฑ์โลหะที่คุณต้องการ
          ตั้งแต่การออกแบบเบื้องต้นจนถึงการส่งมอบขั้นสุดท้าย
          เรามั่นใจว่าทุกขั้นตอนมีความเข้มงวดและพิถีพิถันเพื่อให้แน่ใจว่าคุณจะได้รับไม่เพียงแต่ผลิตภัณฑ์เท่านั้น
          แต่ยังได้รับความไว้วางใจและความพึงพอใจอีกด้วย เมื่อคุณเลือกเรา
          คุณจะเลือกพันธมิตรที่เชื่อถือได้เพื่อเพิ่มมูลค่าและความมั่นใจที่ยั่งยืนให้กับธุรกิจของคุณ</span>
      </div>
    </div>
    <div class="team">
      <div class="bt">ทีมงานของเรา</div>
      <div class="btInfo">ทีมงานของเราเป็นรากฐานสำคัญของความสำเร็จ
        โดยรวบรวมผู้เชี่ยวชาญชั้นนำของอุตสาหกรรมและความสามารถทางเทคนิคเข้าด้วยกัน
        จิตวิญญาณแห่งนวัตกรรมและงานฝีมืออันยอดเยี่ยมของพวกเขานำความเป็นไปได้ที่ไม่มีที่สิ้นสุดมาสู่ทุกโครงการ</div>
      <div class="title">ทีมงานที่หลากหลาย</div>
      <div class="text">บริษัทของเรามีทีมงานสร้างสรรค์ที่แตกต่างกันซึ่งสามารถให้การสนับสนุนในด้านการออกแบบ การผลิต
        และการสนับสนุนทางเทคนิค เพื่อให้ลูกค้าได้รับบริการและโซลูชั่นที่เป็นเลิศ</div>
      <div class="itemBox">
        <div class="item">
          <img src="../assets/team1.png" alt="">
          <p>ทีมออกแบบ</p>
        </div>
        <div class="item">
          <img src="../assets/team2.png" alt="">
          <p>ทีมงานฝ่ายผลิต</p>
        </div>
        <div class="item">
          <img src="../assets/team3.png" alt="">
          <p>ทีมงานโซลูชั่น</p>
        </div>
        <div class="item">
          <img src="../assets/team4.png" alt="">
          <p>ทีมงานเทคนิค</p>
        </div>
      </div>
    </div>
    <div class="history">
      <div class="bt">ประวัติของบริษัท</div>
      <div class="item">
        <div class="num">2024</div>
        <div class="info">
          <p>ในปี 2024 เราตอบสนองอย่างแข็งขันต่อการเรียกร้องการปกป้องสิ่งแวดล้อมและการพัฒนาที่ยั่งยืน
            และนำมาตรการการผลิตที่เป็นมิตรต่อสิ่งแวดล้อมมาใช้ ในเวลาเดียวกัน เราได้ขยายอิทธิพลของเราในตลาดต่างประเทศ
            สร้างความร่วมมือระยะยาวกับลูกค้าทั่วโลก และสร้างตำแหน่งผู้นำของเราในตลาดต่างประเทศ</p>
          <!-- <span></span> -->
        </div>
      </div>
      <div class="item">
        <div class="num">2023</div>
        <div class="info">
          <p>ในปี 2023 เราได้พัฒนานวัตกรรมทางเทคโนโลยีและการพัฒนาผลิตภัณฑ์ให้ลึกซึ้งยิ่งขึ้น
            ด้วยการแนะนำเทคโนโลยีการผลิตอัจฉริยะและสายการผลิตอัตโนมัติ เราได้ปรับกระบวนการผลิตให้เหมาะสม
            ปรับปรุงคุณภาพผลิตภัณฑ์และประสิทธิภาพการจัดส่ง และรับประกันความพึงพอใจของลูกค้าอย่างต่อเนื่อง</p>
        </div>
      </div>
      <div class="item">
        <div class="num">2022</div>
        <div class="info">
          <p>เมื่อเข้าสู่ปี 2022 เราได้เริ่มต้นการขยายตัวอย่างรวดเร็วและการเติบโตของธุรกิจ
            ด้วยการลงทุนในการอัพเกรดอุปกรณ์และการฝึกอบรมพนักงานอย่างต่อเนื่อง
            เราไม่เพียงแต่ปรับปรุงประสิทธิภาพการผลิตเท่านั้น
            แต่ยังขยายสายผลิตภัณฑ์ของเราเพื่อตอบสนองความต้องการของลูกค้าที่หลากหลายของเราอีกด้วย</p>
        </div>
      </div>
      <div class="item">
        <div class="num">2021</div>
        <div class="info">
          <p>ก่อตั้งขึ้นในปี 2021 ด้วยนวัตกรรมและความหลงใหล เรามุ่งมั่นที่จะมอบโซลูชันผลิตภัณฑ์โลหะคุณภาพสูงให้กับลูกค้า
            ด้วยการแนะนำเทคโนโลยีการผลิตขั้นสูงและมาตรฐานการจัดการคุณภาพ
            เราจึงสร้างชื่อเสียงที่ดีในอุตสาหกรรมได้อย่างรวดเร็ว</p>
        </div>
      </div>
    </div>
    <footerBox></footerBox>
  </div>
</template>
<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
  name: "projects",
  components: {
    menuBox,
    footerBox,
  },
  data() {
    return {
    };
  },
  mounted() { },
  methods: {
    submit() {
      alert('ความสำเร็จ!')
    }
  },
};
</script>
<style lang="less" scoped>
.projects-box {
  .title-box {
    background-image: url(../assets/projects.png);
    width: 100%;
    height: 420px;
    background-size: 100% 100%;
    overflow: hidden;
    padding: 160px 360px 0 360px;
    text-align: center;
    box-sizing: border-box;

    .title {
      float: right;
      width: 600px;
      text-align: right;

      p {
        margin-bottom: 20px;
        font-size: 56px;
        color: #FFFFFF;
        line-height: 67px;
      }

      span {
        font-size: 20px;
        color: #FFFFFF;
        line-height: 24px;
      }
    }
  }
}

.team {
  padding: 100px 360px 100px;
  text-align: center;

  .bt {
    margin-bottom: 24px;
    font-size: 40px;
    color: #333333;
    line-height: 48px;
    text-align: left;
  }

  .btInfo {
    margin-bottom: 48px;
    font-size: 16px;
    color: #333333;
    line-height: 28px;
    text-align: left;
  }

  .title {
    margin-bottom: 28px;
    padding: 12px 0;
    font-size: 32px;
    color: #F65331;
    line-height: 38px;
    border-top: 1px solid #999;
    border-bottom: 1px solid #999;
  }

  .text {
    margin-bottom: 48px;
    font-size: 16px;
    color: #999999;
    line-height: 28px;
  }

  .itemBox {
    display: flex;
    justify-content: space-between;

    .item {
      margin-right: 100px;

      img {
        margin-bottom: 20px;
        width: 200px;
        height: 200px
      }

      p {
        font-size: 24px;
        color: #333333;
        line-height: 29px;
      }
    }

    .item:last-child {
      margin-right: 0;
    }
  }
}

.history {
  padding: 0 360px 180px;

  .bt {
    margin-bottom: 32px;
    font-size: 40px;
    color: #333333;
    line-height: 48px;
  }

  .item {
    display: flex;
    align-items: flex-start;
    margin-bottom: 48px;

    .num {
      padding: 14px 18px;
      margin-right: 24px;
      background: #EEEEEE;
      box-sizing: border-box;
      font-size: 30px;
      color: #999999;
    }

    .info {
      p {
        margin-bottom: 10px;
        font-size: 20px;
        color: #F65331;
        line-height: 24px;
      }

      span {
        font-size: 16px;
        color: #999999;
        line-height: 19px;
      }
    }
  }

  .item:last-child {
    margin-bottom: 0;
  }
}
</style>
